import { Container, Row } from "reactstrap";
import { Col } from "react-bootstrap";
import { Breadcrumbs } from '../../AbstractElements';
import React, { Fragment } from 'react'
import PayinPayoutHome from "./PayinPayoutHome";
import { useTranslation } from "react-i18next";

export default function PayinPayout() {
    const { t } = useTranslation();
    return (
        <Fragment>
            <Breadcrumbs mainTitle={t("List of Paid-in Paid-out")} parent={t("Home")} title={t("List of Paid-in Paid-out")} />
            <Container fluid={true}>
                <Row>
                    <Col className="h-100">
                       <PayinPayoutHome />
                    </Col>
                </Row>
            </Container>
        </Fragment>
    )
}
